module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages__form"
  }, [_c('div', {
    staticClass: "ui inverted form"
  }, [_c('form', {
    attrs: {
      "action": "",
      "id": "form"
    }
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "message",
      "id": "message",
      "rows": "3",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        if (!$event.ctrlKey) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "ui green button",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendMessage($event)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.sendMessage($event)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "ui labeled icon button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openFileModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "cloud upload icon"
  }), _vm._v("Fichier")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small orange inverted progress",
    attrs: {
      "data-total": "100",
      "id": "uploadedFile"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.uploadLabel))])]), _vm._v(" "), _c('file-modal', {
    ref: "file_modal"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23479002"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/MessageForm.vue
// module id = 220
// module chunks = 1